export default "__VITE_ASSET__B8ej7oYS__"